import { AuthResponseBody } from '../../core/theme'
import { apiEndpointAction, WHMCS_ROOT } from '../../utils/variables'

const HTTP_AUTH = apiEndpointAction('auth', 'user')

const getAuthDetails = async (): Promise<AuthResponseBody> => {
  try {
    const responseRAW = await fetch(HTTP_AUTH, {
      method: 'GET',
      mode: 'cors',
      credentials: 'include'
    })

    const contentType = responseRAW.headers.get('content-type') ?? ''
    if (!responseRAW.ok || !contentType.includes('application/json')) {
      return { error: true }
    }

    const response: unknown = await responseRAW.json()
    if (
      response === null ||
      typeof response !== 'object' ||
      Array.isArray(response) ||
      typeof (response as { error?: unknown }).error !== 'boolean'
    ) {
      return { error: true }
    }

    return response as AuthResponseBody
  } catch {
    return { error: true }
  }
}

export const setupAuth = async (
  loginLogoutButtons: NodeListOf<HTMLAnchorElement>,
  registerClientAreaButtons: NodeListOf<HTMLAnchorElement>
): Promise<void> => {
  const authDetails = await getAuthDetails()

  const editButton = (
    button: HTMLAnchorElement,
    url: string,
    cssReplace: [oldToken: string, newToken: string],
    btnText: string
  ): void => {
    const iconEL = button.querySelector('.icon')
    const textEL = button.querySelector('.text')

    if (!iconEL) {
      throw new Error('Auth: icon holder is missing')
    }

    if (!textEL) {
      throw new Error('Auth: text holder is missing')
    }

    button.href = `${WHMCS_ROOT}/${url}`
    iconEL.classList.replace(cssReplace[0], cssReplace[1])
    textEL.textContent = btnText
  }

  if (!authDetails.error) {
    loginLogoutButtons.forEach((button): void => {
      editButton(
        button,
        'logout.php',
        ['fa-user', 'fa-chevron-circle-left'],
        'logout'
      )
    })

    registerClientAreaButtons.forEach((button) => {
      editButton(
        button,
        'clientarea.php',
        ['fa-user-plus', 'fa-info-circle'],
        'Client Area'
      )
    })
    return
  }

  loginLogoutButtons.forEach((button): void => {
    editButton(
      button,
      'index.php?rp=/login',
      ['fa-chevron-circle-left', 'fa-user'],
      'Login'
    )
  })

  registerClientAreaButtons.forEach((button) => {
    editButton(
      button,
      'register.php',
      ['fa-info-circle', 'fa-user-plus'],
      'Register'
    )
  })
}
